import { render, staticRenderFns } from "./crossCheckAiOcrDetail.vue?vue&type=template&id=59d7f2bd&scoped=true&"
import script from "./crossCheckAiOcrDetail.vue?vue&type=script&lang=js&"
export * from "./crossCheckAiOcrDetail.vue?vue&type=script&lang=js&"
import style0 from "./crossCheckAiOcrDetail.vue?vue&type=style&index=0&id=59d7f2bd&lang=scss&scoped=true&"
import style1 from "./crossCheckAiOcrDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d7f2bd",
  null
  
)

export default component.exports